// Lazy loads the instructor images in the navbar dropdown

$(document).ready(function() {

  $('.js-lazyload-instructor').each(function(){
    if ( $(this).attr('data-src') ) {
      $(this).attr('src', $(this).attr('data-src'));
    }
  });

});
